import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import type { SchoolViewType } from '../../pages/types';
import { Toggle } from '../../components';
import { APP_THEME } from '../../styles/theme/styled/theme';
import { useI18n } from '@whizz/react-i18n';

export const useClassYearToggle = (): (React.ReactElement | SchoolViewType | null)[] => {
  const { translate } = useI18n();

  const [ toggle, setToggle ] = useState(<></>);
  const [ value, setValue ] = useState<SchoolViewType>('class');

  useEffect(() => {
    setToggle(
      <div className={'flex mx-auto'} style={{
        height: APP_THEME.sizes.md,
        minWidth: 150,
      }}>
        <div
          className={'bg-white flex items-center justify-center w-full px-4'}
          style={{
            boxShadow: APP_THEME.shadows.md,
            borderRadius: APP_THEME.radius.input,
          }}
        >
          <button className={'appearance-none'} onClick={() => setValue('class')}>
            <div
              className={classnames({ 'opacity-50 text-xs' : value !== 'class' }, { 'font-bold text-sm' : value === 'class' })}
            >
              {translate('settings.SCHOOL_REPORT_TOGGLE.class')}
            </div>
          </button>
          <div className={'mx-sm'}>
            <Toggle
              id={'class-year'}
              label={'Class year'}
              color={'dark'}
              checked={value === 'year'}
              onChange={() => {
                setValue(value === 'year' ? 'class' : 'year');
              }}
            />
          </div>
          <button className={'appearance-none'} onClick={() => setValue('year')}>
            <div
              className={classnames({ 'opacity-50 text-xs' : value !== 'year' }, { 'font-bold text-sm' : value === 'year' })}
            >
              {translate('settings.SCHOOL_REPORT_TOGGLE.year')}
            </div>
          </button>
        </div>
      </div>,
    );
  }, [ value ]);

  return [ toggle, value ];
};
